
























import { Component, Prop, Vue } from 'vue-property-decorator'

import SearchOverlay from '@/components/SearchOverlay.vue'

@Component({
  components: {
    SearchOverlay
  }
})
export default class extends Vue {
  @Prop(String) readonly placeholder!: string
  searchActivated = false

  onClickSearch () {
    this.searchActivated = true
  }
}
